import { Amplify, DataStore } from "aws-amplify";
import { AuthModeStrategyType } from "@aws-amplify/datastore";
import awsconfig from "./aws-exports";

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// The GraphQL models are protected by Cognito User Pools (@auth provider:
// userPools). Some generated aws-exports.js builds set the default AppSync
// auth type to API_KEY, which makes DataStore queries fail with
// "User is unauthorized ... with auth mode API_KEY". Force the correct auth
// type here so the app works regardless of what the build generates.
Amplify.configure({
  ...awsconfig,
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
});

// Let DataStore pick the right auth mode per model based on its @auth rules
// (multi-auth), so authenticated users use their Cognito session.
DataStore.configure({
  authModeStrategyType: AuthModeStrategyType.MULTI_AUTH,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Start DataStore and wait for sync to complete before rendering
DataStore.start().then(() => {
  console.log("DataStore synced and ready");
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((error) => {
  console.error("DataStore failed to start:", error);
  // Render anyway so user can still use the app
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
